import type {
  ListValorantAgentsResponse,
  ValorantAgentRole,
  ValorantAgentStats,
} from 'generated/openapi';

/**
 * Get the agent icon URL from Valorant API
 */
export const getAgentIconUrl = (agentId: string): string =>
  `https://media.valorant-api.com/agents/${agentId}/displayicon.png`;

/**
 * Get the most played role based on agent match counts
 */
export function getMostPlayedRole(
  agents: Record<string, ValorantAgentStats> | undefined,
  agentsData: ListValorantAgentsResponse | undefined,
): ValorantAgentRole | null {
  if (!agents || !agentsData?.agents) {
    return null;
  }

  // Create Map for O(1) agent lookups
  const agentsById = new Map(
    agentsData.agents.map(a => [a.uuid.toLowerCase(), a]),
  );

  // Calculate total match count per role
  const roleMatchCounts: Record<ValorantAgentRole, number> = {
    CONTROLLER: 0,
    DUELIST: 0,
    INITIATOR: 0,
    SENTINEL: 0,
  };

  Object.entries(agents).forEach(([agentId, stats]) => {
    const agent = agentsById.get(agentId.toLowerCase());
    if (agent) {
      roleMatchCounts[agent.role] += stats.matchCount;
    }
  });

  // Find role with highest match count
  let maxRole: ValorantAgentRole | null = null;
  let maxCount = 0;

  for (const [role, count] of Object.entries(roleMatchCounts) as [
    ValorantAgentRole,
    number,
  ][]) {
    if (count > maxCount) {
      maxCount = count;
      maxRole = role;
    }
  }

  return maxRole;
}
